export enum LorenGeofenceConditionEnum {
    IN_AREA = 'IN_AREA',
    OUT_OF_AREA = 'OUT_OF_AREA'
}
